module.exports = __webpack_public_path__ + "img/print.6bb204db.svg";